import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, FormControl, ControlLabel } from 'react-bootstrap';

/**
 * Concerns of this component:
 *   provide a form to select a group
**/
class GroupSelect extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.setGroup(event.target.value);
  }

  render() {
    const { groups } = this.props;

    // sort asc by display_label
    groups.sort((a, b) => {
      if (a.display_label < b.display_label) { return -1; }
      if (a.display_label > b.display_label) { return 1; }
      return 0;
    });

    return (
      <FormGroup>
        <ControlLabel>{this.props.label || 'in food group(s)'}</ControlLabel>
        <FormControl
          componentClass="select"
          name="group"
          value={this.props.selected}
          onChange={this.handleChange}
        >
          <option value="all">All</option>
          {groups.map((group) => (
            <option value={group.code} key={group.code}>{group.display_label}</option>
          ))}
        </FormControl>
      </FormGroup>
    );
  }
}

GroupSelect.propTypes = {
  groups: PropTypes.array.isRequired,
  selected: PropTypes.string.isRequired,
  setGroup: PropTypes.func.isRequired,
  label: PropTypes.string,
};

export default GroupSelect;



// WEBPACK FOOTER //
// ./src/components/search/common/GroupSelect.js